// react
import React, { ReactNode } from "react";

import BaseModal, { BaseModalProps } from "./BaseModal";

import Spacer from "../Spacer";
// styles
import css from "./Modal.module.scss";

interface ModalProps extends BaseModalProps {
	/**
	 * The content of the modal. Rendered in the body of the modal.
	 */
	content: ReactNode;
	/**
	 * The buttons of the modal (usually a cancel and confirm button).
	 * Rendered in the footer of the modal.
	 */
	buttons?: ReactNode;
	/**
	 * The style of modal content.
	 * @default null
	 * @type scss class
	 */
	contentClassName?: string;
}

export const Modal = (props: ModalProps) => {
	const {
		buttons = null,
		content = null,
		handleClose,
		size = "small",
		contentClassName,
		wrapperClassName,
		isOpen = true,
	} = props;

	return (
		<BaseModal isOpen={isOpen} size={size} wrapperClassName={wrapperClassName} handleClose={handleClose}>
			<Spacer height={1} />
			<div data-testid="modalContent" className={contentClassName || css.modalContent}>
				{content}
			</div>
			<Spacer height={3} />
			{buttons && (
				<div data-testid="modalButtons" className={css.modalButtons}>
					{buttons}
				</div>
			)}

			<Spacer height={2} />
		</BaseModal>
	);
};

export default Modal;
